import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SeoRouteData, SeoService } from './core/services/seo.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {

  title = 'cmp-website';
  hideCommonLayout: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private seoService: SeoService
  ) { }

  ngOnInit(): void {
    this.updateLayoutVisibility(this.router.url);
    this.updateSeo(this.router.url);

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.updateLayoutVisibility(event.urlAfterRedirects);
        this.updateSeo(event.urlAfterRedirects);
      });
  }

  private updateLayoutVisibility(url: string): void {
    this.hideCommonLayout = url.startsWith('/dynamics-365');
  }

  private updateSeo(url: string): void {
    const route = this.getDeepestRoute(this.activatedRoute);
    const routeSeo = route.snapshot.data['seo'] as Partial<SeoRouteData> | undefined;
    this.seoService.updateRouteSeo(url, routeSeo);
  }

  private getDeepestRoute(route: ActivatedRoute): ActivatedRoute {
    let activeRoute = route;
    while (activeRoute.firstChild) {
      activeRoute = activeRoute.firstChild;
    }
    return activeRoute;
  }

}
